export class ProductsOrderModel {
  constructor (products, filters, name) {
    this.name = name;
    this.filters = filters;
    this.products = products.map(product => product.id);
  }
}
